import { SVGProps } from "react";

export function TriggerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16 8A8 8 0 110 8a8 8 0 0116 0z" fill="#FAFAFA" />
      <path
        clipRule="evenodd"
        d="M8 16A8 8 0 108 0a8 8 0 000 16zM7 5a1 1 0 112 0 1 1 0 01-2 0zm1 3a1 1 0 011 1v2a1 1 0 11-2 0V9a1 1 0 011-1z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
